import manifest from './original-soundtrack.json';
import { MAIN_WORLD } from './world';

let runtimeMaps:Record<string,string>|undefined;
let refreshing:Promise<void>|undefined;
let refreshed=0;
const listeners=new Set<()=>void>();
let refreshTimer:ReturnType<typeof setInterval>|undefined;
const safeTrack=(value:unknown):value is string=>typeof value==='string'&&manifest.tracks.includes(value);
/** Music settings are optional background data: never block map or SFX loading. */
export function refreshOriginalSoundtrack(force=false):Promise<void>{
  if(refreshing)return refreshing;
  if(!force&&Date.now()-refreshed<60_000)return Promise.resolve();
  refreshed=Date.now();
  refreshing=(async()=>{
    try{
      const response=await fetch(MAIN_WORLD?'/api/main/music':'/api/music',{cache:'no-store',signal:AbortSignal.timeout(4000)});
      if(!response.ok)return;const data=await response.json();
      if(data.world!==(MAIN_WORLD?'main':'legacy')||!data.maps||typeof data.maps!=='object'||Array.isArray(data.maps))return;
      const entries=Object.entries(data.maps);
      if(entries.length>10000||entries.some(([id,t])=>!/^\d{1,5}$/.test(id)||Number(id)>=60000||!safeTrack(t)))return;
      const maps=Object.fromEntries(entries) as Record<string,string>;
      if(JSON.stringify(runtimeMaps)!==JSON.stringify(maps)){runtimeMaps=maps;for(const listener of listeners)listener();}
    }catch{/* Embedded approved recordings remain available offline. */}
  })().finally(()=>{refreshing=undefined;});
  return refreshing;
}
export function subscribeOriginalSoundtrack(listener:()=>void):()=>void{
 listeners.add(listener);
 if(!refreshTimer)refreshTimer=setInterval(()=>{if(document.visibilityState==='visible')void refreshOriginalSoundtrack();},60_000);
 return()=>{listeners.delete(listener);if(!listeners.size&&refreshTimer){clearInterval(refreshTimer);refreshTimer=undefined;}};
}

/** Original recordings; music never participates in map loading or the SFX graph. */
export function originalMapTrack(mapId: number, name: string): string {
  const maps = manifest.maps[MAIN_WORLD ? 'monument' : 'legacy'] as Record<string, string>;
  if (mapId >= 60000) {
    if (/house|home|guild/i.test(name)) return 'sunlight_valley_quest.ogg';
    return 'dungeon_dragon.mp3';
  }
  return runtimeMaps?.[String(mapId)] ?? maps[String(mapId)] ?? manifest.fallback;
}
export const originalMenuTrack = manifest.menu;
export function originalMusicTrack(id: number, jukebox = false): string {
  if (!jukebox && id === 1) return manifest.menu;
  return manifest.tracks[Math.abs(Math.trunc(id) - 1) % manifest.tracks.length];
}
